"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/es6.number.constructor");require("core-js/modules/es6.function.name");require("core-js/modules/es6.array.find-index");require("core-js/modules/web.dom.iterable");






















































































































































var _formatter = require("@/utils/formatter");
var _user = require("@/utils/user");
var _lodash = _interopRequireDefault(require("lodash")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { name: '', deviceTypeId: '', type: '', isForce: '', rangeType: '', page: 1, rows: 10 }, //搜索表单
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, //分页数据
      showDialog: false, //是否显示新增||编辑弹窗
      typeList: [{ value: 1, label: '中心板' }, { value: 2, label: 'WiFi板' }, { value: 3, label: '语音板' }, { value: 4, label: '机芯板' }, { value: 5, label: '小腿板' }], //升级模块类型列表
      forceList: [{ value: 0, label: '不强制' }, { value: 1, label: '强制' }], //是否强制升级筛选列表
      rangeList: [{ value: 1, label: '全国升级' }, { value: 2, label: '区域升级' }, { value: 3, label: '精准升级' }], //升级范围列表
      hwRangeList: [{ value: 1, label: '全域升级' }, { value: 3, label: '精准升级' }], //海外升级范围列表
      tableColumns: [{ prop: 'name', label: '升级任务名称' }, { prop: 'deviceTypeCode', label: '设备型号' }, { prop: 'type', label: '升级模块', formatter: _formatter.hardwareModuleTypeFormatter }, { prop: 'versionInfoName', label: '升级版本号' }, { prop: 'isForce', label: '是否强制升级', formatter: _formatter.otaIsForceFormatter }, { prop: 'rangeType', label: '升级范围', formatter: _formatter.otaRangeformatter }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter }, { prop: 'auditTime', label: '审核发布时间', formatter: _formatter.dateFormatter }, { prop: 'auditStatus', label: '状态', formatter: _formatter.otaAuditStatusFormatter }], //表格信息
      list: [], //表格数据
      upgradeForm: { id: 0, name: '', deviceTypeId: '', type: '1', hardwareModuleId: '', versionInfoId: '', isForce: '0', rangeType: '', rangeInfo: '', description: '' }, //新增||编辑表单
      upgradeFormRule: { name: [{ required: true, message: '请填写升级任务名称', trigger: ['blur', 'change'] }], deviceTypeId: [{ required: true, message: '请选择设备型号', trigger: ['blur', 'change'] }], type: [{ required: true, message: '请选择升级模块', trigger: ['blur', 'change'] }], hardwareModuleId: [{ required: true, message: '请选择硬件', trigger: ['blur', 'change'] }], versionInfoId: [{ required: true, message: '请选择升级版本', trigger: ['blur', 'change'] }], isForce: [{ required: true,
          message: '请选择是否强制升级',
          trigger: ['blur', 'change'] }],

        rangeType: [{
          required: true,
          message: '请选择升级范围',
          trigger: ['blur', 'change'] }],

        description: [{
          required: true,
          message: '请填写版本说明',
          trigger: ['blur', 'change'] }] },

      //表单验证规则
      regionList: [], //省市列表
      deviceSn: '', //设备搜索关键词
      deviceTableColumns: [
      {
        prop: 'deviceTypeCode',
        label: '设备型号' },

      {
        prop: 'sn',
        label: '设备序列号' }],

      //表格信息
      deviceList: [], //设备列表
      hardwareList: [], //硬件列表
      versionList: [], //版本列表
      deviceTypeCodeList: [], //设备型号列表
      editDisable: false, //是否禁用编辑
      currentUpgradeInfo: '', //当前编辑升级信息
      upgradeEdit: false, //是否正在编辑升级包
      editDeviceList: [] //编辑时已选中的设备列表
    };
  },

  mounted: function mounted() {
    this.initPage();
  },

  computed: {
    hardwareLabel: function hardwareLabel() {
      switch (parseInt(this.upgradeForm.type)) {
        case 1:
          return '中心板硬件';
          break;
        case 2:
          return 'WiFi板硬件';
          break;
        case 3:
          return '语音板硬件';
          break;
        case 4:
          return '机芯板硬件';
          break;
        case 5:
          return '小腿板硬件';
          break;
        default:
          return '';
          break;}

    },

    /**
        * 已选的设备列表
        */
    selectedList: function selectedList() {var _this = this;
      var list = _lodash.default.filter(this.deviceList, function (o) {return o.selected;});
      this.$nextTick(function () {
        list.forEach(function (e) {
          _this.$refs.deviceSelectedTable.toggleRowSelection(e, true);
        });
      });
      list = list.concat(this.editDeviceList);
      list = _lodash.default.unionBy(list, 'sn');
      return list;
    },

    /**
        * 待选择设备列表
        */
    unSelectedList: function unSelectedList() {var _this2 = this;
      var list = _lodash.default.filter(this.deviceList, function (o) {return !o.selected;});
      this.$nextTick(function () {
        list.forEach(function (e) {
          _this2.$refs.deviceTable.toggleRowSelection(e, false);
        });
      });
      return list;
    },

    versionLabel: function versionLabel() {
      switch (parseInt(this.upgradeForm.type)) {
        case 1:
          return '中心板升级版本';
          break;
        case 2:
          return 'WiFi板升级版本';
          break;
        case 3:
          return '语音板升级版本';
          break;
        case 4:
          return '机芯板升级版本';
          break;
        case 5:
          return '小腿板升级版本';
          break;
        default:
          return '';
          break;}

    },

    //是否为海外环境
    isOverseas: function isOverseas() {
      if (process.env.VUE_APP_OG_ENV == 'americaDevelopment' || process.env.VUE_APP_OG_ENV == 'asiaProduction' || process.env.VUE_APP_OG_ENV == 'americaProduction') {
        //海外
        return true;
      } else {
        //国内||测试环境
        return false;
      }
    } },


  methods: {
    /**
              * 按钮粒度权限校验
              */
    checkPermission: _user.checkPermission,

    /**
                                             * 表格头全选按钮样式
                                             */
    leftHeaderStyle: function leftHeaderStyle(_ref) {var row = _ref.row,column = _ref.column,rowIndex = _ref.rowIndex,columnIndex = _ref.columnIndex;
      if (columnIndex == 0 && this.editDisable) {
        return 'allSelBtnDis';
      }
    },

    /**
        * 精准升级-设备选中事件回调
        */
    onDeviceSelect: function onDeviceSelect(selection, row) {
      row.selected = true;
    },

    /**
        * 精准升级-设备全选
        */
    onDeviceSelectAll: function onDeviceSelectAll(selection) {
      this.deviceList.forEach(function (e) {
        e.selected = true;
      });
    },

    /**
        * 精准升级-设备取消选中事件回调
        */
    onDeviceSelectCancel: function onDeviceSelectCancel(selection, row) {
      // if (this.upgradeForm.id) {
      //   this.upgradeForm.rangeInfo.data = lodash.filter(this.upgradeForm.rangeInfo.data, (o) => {return o.sn != row.sn})
      // }
      var index = _lodash.default.findIndex(this.editDeviceList, function (o) {return o.sn == row.sn;});
      if (index >= 0) {
        this.editDeviceList.splice(index, 1);
      }
      row.selected = false;
    },

    /**
        * 精准升级-设备取消全选
        */
    onDeviceSelectAllCancel: function onDeviceSelectAllCancel() {
      // if (this.upgradeForm.id) {
      //   this.upgradeForm.rangeInfo.data = []
      // }
      this.editDeviceList = [];
      this.deviceList.forEach(function (e) {
        e.selected = false;
      });
    },

    /**
        * 页面初始化
        */
    initPage: function initPage() {
      this.fetchVersionJobList();
      this.fetchFaRegion();
      this.fetchDeviceTypeCodeList();
      this.fetchHardwareModuleGetDownList(1);
    },

    /**
        * 获取升级任务列表接口
        */
    fetchVersionJobList: function fetchVersionJobList() {var _this3 = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/versionJob', params, function (res) {
        _this3.list = res.list;
        _this3.pageData.page = res.pageNum;
        _this3.pageData.total = res.total;
      });
    },

    /**
        * 获取省市县列表
        */
    fetchFaRegion: function fetchFaRegion() {var _this4 = this;
      this.getData('/api/faRegion', {}, function (res) {
        _this4.regionList = res;
      });
    },

    /**
        * 获取设备型号列表
        */
    fetchDeviceTypeCodeList: function fetchDeviceTypeCodeList() {var _this5 = this;
      this.getData('/api/faDeviceType', { page: 1, rows: 99999999 }, function (res) {
        _this5.deviceTypeCodeList = res.list;
      });
    },

    /**
        * 获取硬件列表
        */
    fetchHardwareModuleGetDownList: function fetchHardwareModuleGetDownList(type) {var _this6 = this;
      this.getData('/api/hardwareModule/getDownList?type=' + type, {}, function (res) {
        _this6.hardwareList = res;
      });
    },

    /**
        * 获取版本列表
        */
    fetchVersionList: function fetchVersionList() {var _this7 = this;
      this.getData('/api/versionInfo/getDownList?hardwareModuleId=' + this.upgradeForm.hardwareModuleId, {}, function (res) {
        _this7.versionList = res;
      });
    },

    /**
        * 根据设备型号及序列号获取设备列表
        */
    fetchDeviceList: function fetchDeviceList() {var _this8 = this;
      var url = '/api/faDeviceInfo/getAllBySn?deviceTypeId=' + this.upgradeForm.deviceTypeId;
      if (this.deviceSn) {
        url += '&sn=' + this.deviceSn;
      }
      this.getData(url, {}, function (res) {
        if (_this8.upgradeForm.id) {
          _this8.$nextTick(function () {
            res.list.forEach(function (e) {
              e.selected = false;
              _this8.upgradeForm.rangeInfo.data.forEach(function (device) {
                if (e.sn == device.sn) {
                  e.selected = true;
                  _this8.$refs.deviceTable.toggleRowSelection(e, true);
                }
              });
            });
            res.list = _lodash.default.uniqBy(res.list.concat(_this8.selectedList), 'sn');
            res.list.forEach(function (e) {
              _this8.selectedList.forEach(function (o) {
                if (e.sn == o.sn) {
                  e.selected = true;
                }
              });
            });
            _this8.deviceList = res.list;
          });
        } else {
          res.list.forEach(function (e) {
            e.selected = false;
          });
          res.list = _lodash.default.uniqBy(res.list.concat(_this8.selectedList), 'sn');
          res.list.forEach(function (e) {
            _this8.selectedList.forEach(function (o) {
              if (e.sn == o.sn) {
                e.selected = true;
              }
            });
          });
          _this8.deviceList = res.list;
        }
      });
    },

    /**
        * 获取设备的SN
        */
    getDeviceRowKey: function getDeviceRowKey(row) {
      return row.sn;
    },

    /**
        * 设备表格是否可选
        */
    tableColumnSelectable: function tableColumnSelectable() {
      if (this.editDisable) {
        return false;
      } else {
        return true;
      }
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'name', '');
      this.$set(this.searchData, 'deviceTypeId', '');
      this.$set(this.searchData, 'type', '');
      this.$set(this.searchData, 'isForce', '');
      this.$set(this.searchData, 'rangeType', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchVersionJobList();
    },

    /**
        * 每页size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.fetchVersionJobList();
    },

    /**
        * 页码-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.fetchVersionJobList();
    },

    /**
        * 编辑 || 查看
        */
    onClickUpdate: function onClickUpdate(row) {var _this9 = this;
      if (parseInt(row.auditStatus) == 0) {
        this.editDisable = false;
        this.upgradeEdit = true;
        this.currentUpgradeInfo = Object.assign({}, row);
      } else {
        this.editDisable = true;
      }
      this.showDialog = true;
      this.$set(this.upgradeForm, 'id', row.id);
      this.$set(this.upgradeForm, 'name', row.name);
      this.$set(this.upgradeForm, 'deviceTypeId', Number(row.deviceTypeId));
      this.$set(this.upgradeForm, 'type', row.type + '');
      this.$set(this.upgradeForm, 'hardwareModuleId', Number(row.hardwareModuleId));
      this.$set(this.upgradeForm, 'versionInfoId', Number(row.versionInfoId));
      this.$set(this.upgradeForm, 'isForce', row.isForce + '');
      this.$set(this.upgradeForm, 'rangeType', row.rangeType + '');
      this.$set(this.upgradeForm, 'rangeInfo', row.rangeInfo ? JSON.parse(row.rangeInfo) : '');
      this.$set(this.upgradeForm, 'description', row.description);
      this.fetchHardwareModuleGetDownList(row.type);
      this.fetchVersionList();
      if (parseInt(row.rangeType) == 2) {
        //区域升级
        var temp = [];
        this.upgradeForm.rangeInfo.data.forEach(function (e) {
          temp.push([e.province, e.city]);
        });
        this.upgradeForm.rangeInfo = temp;
      }
      if (parseInt(row.rangeType) == 3) {
        //精准升级
        this.fetchDeviceList();
        if (row.rangeInfo) {
          var rangeInfo = JSON.parse(row.rangeInfo);
          rangeInfo.data.forEach(function (e) {
            _this9.editDeviceList.push({
              deviceTypeCode: row.deviceTypeCode,
              sn: e.sn,
              selected: true });

          });
        }
      }
    },

    /**
        * 删除 || 反审核
        */
    onClickDelete: function onClickDelete(row) {var _this10 = this;
      if (parseInt(row.auditStatus) == 0) {
        //删除
        this.$confirm('确定删除当前升级任务？', '提示', { type: 'warning' }).then(function (res) {
          //删除升级任务
          _this10.delData('/api/versionJob', { id: row.id }, function (res) {
            _this10.fetchVersionJobList();
          });
        }).catch(function (err) {

        });
      } else {
        //反审核
        this.$confirm('您确定要反审核该发布版本？', '反审核', { type: 'warning' }).then(function (res) {
          //反审核
          _this10.getData('/api/versionJob/reverseAuditByid/' + row.id, {}, function (res) {
            _this10.fetchVersionJobList();
          });
        }).catch(function (err) {

        });
      }
    },

    /**
        * 审核
        */
    onClickExamine: function onClickExamine(row) {var _this11 = this;
      this.$confirm('您确定已经配置完功能，审核发包版本？', '审核发包', { type: 'warning' }).then(function (res) {
        //审核
        _this11.getData('/api/versionJob/auditByid/' + row.id, {}, function (res) {
          _this11.fetchVersionJobList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 新增||编辑表单关闭
        */
    onDialogClose: function onDialogClose() {var _this12 = this;
      this.$nextTick(function () {
        Object.keys(_this12.upgradeForm).forEach(function (key) {
          _this12.$set(_this12.upgradeForm, key, key == 'id' ? 0 : '');
        });
        _this12.$set(_this12.upgradeForm, 'type', '1');
        _this12.$refs.upgradeForm.clearValidate();
      });
      this.showDialog = false;
      this.editDisable = false;
      this.upgradeEdit = false;
      this.deviceList = [];
      this.deviceSn = '';
      this.editDeviceList = [];
      this.currentUpgradeInfo = '';
    },

    /**
        * 设备型号-change
        */
    onDeviceTypeChange: function onDeviceTypeChange(value) {
      this.fetchDeviceList();
    },

    /**
        * 升级模块类型-change
        */
    onModuleTypeChange: function onModuleTypeChange(type) {
      this.$set(this.upgradeForm, 'hardwareModuleId', '');
      this.$set(this.upgradeForm, 'versionInfoId', '');
      this.fetchHardwareModuleGetDownList(type);
    },

    /**
        * 硬件-change
        */
    onHardwareModuleIdChange: function onHardwareModuleIdChange(event) {
      this.$set(this.upgradeForm, 'versionInfoId', '');
      this.fetchVersionList();
    },

    /**
        * 搜索设备
        */
    onClickSearchDevice: function onClickSearchDevice() {

    },

    /**
        * 保存升级信息
        */
    onSubmitUpgradeInfo: function onSubmitUpgradeInfo() {var _this13 = this;
      if (parseInt(this.upgradeForm.rangeType) == 2 && !this.upgradeForm.rangeInfo) {
        //区域升级
        this.$message({
          type: 'error',
          message: '请选择需要升级的区域' });

        return;
      }
      if (parseInt(this.upgradeForm.rangeType) == 3 && this.selectedList.length <= 0) {
        //精准升级
        this.$message({
          type: 'error',
          message: '请选择需要升级的设备' });

        return;
      }
      this.$refs.upgradeForm.validate(function (valid) {
        if (valid) {
          var params = Object.assign({}, _this13.upgradeForm);
          var temp = { data: [] };
          if (parseInt(_this13.upgradeForm.rangeType) == 2) {
            //区域升级
            params.rangeInfo.forEach(function (e) {
              temp.data.push({ province: e[0], city: e[1] });
            });
          }
          if (parseInt(_this13.upgradeForm.rangeType) == 3) {
            //精准升级
            _this13.selectedList.forEach(function (e) {
              temp.data.push({ sn: e.sn });
            });
          }
          // console.log('params====>',params)
          params.rangeInfo = JSON.stringify(temp);
          if (params.id) {
            //编辑
            params.createTime = _this13.currentUpgradeInfo.createTime;
            params.auditStatus = _this13.currentUpgradeInfo.auditStatus;
            params.auditUserId = _this13.currentUpgradeInfo.auditUserId;
            params.auditTime = _this13.currentUpgradeInfo.auditTime;
            _this13.putData('/api/versionJob', params, function (res) {
              _this13.onDialogClose();
              _this13.fetchVersionJobList();
            });
          } else {
            //新增
            delete params['id'];
            _this13.postData('/api/versionJob', params, function (res) {
              _this13.onDialogClose();
              _this13.$set(_this13.searchData, 'page', 1);
              _this13.fetchVersionJobList();
            });
          }
        }
      });
    } } };exports.default = _default;